/* eslint-disable max-len */
import { CognitoData } from "./CognitoData";

/**
 * The function `GetBranchId` retrieves the branch ID based on the user type and returns it.
 * @returns the value of the `branch_id` variable.
 */
export async function GetBranchId() {
    const user = await CognitoData();
    let branch_id = ""
    if(user.idToken.payload["custom:user_type"] === "institution-user" || user.idToken.payload["custom:user_type"] ===  "institution-admin") {
        branch_id = JSON.parse(localStorage.getItem('branch_details')) === null ? "" : JSON.parse(localStorage.getItem('branch_details')).id
    } else {
        branch_id = user.idToken.payload["custom:branch_id"]
    }
    return branch_id;
}